import { render, staticRenderFns } from "./CheckFlows.vue?vue&type=template&id=edb93756&scoped=true"
import script from "./CheckFlows.vue?vue&type=script&lang=js"
export * from "./CheckFlows.vue?vue&type=script&lang=js"
import style0 from "./CheckFlows.vue?vue&type=style&index=0&id=edb93756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb93756",
  null
  
)

export default component.exports